import React, { useState, useEffect } from "react";
import Checkbox from "@mui/material/Checkbox";

type OptionProps = {
  name: string;
  code: string;
};

type RolesAndPermissionCardsProps = {
  headerTitle: string;
  options: OptionProps[];
  onSelectionChange?: (selectedCodenames: OptionProps[]) => void;
  selectedOptions?: OptionProps[];
};

const RolesAndPermissionCards: React.FC<RolesAndPermissionCardsProps> = ({
  headerTitle,
  options,
  onSelectionChange,
  selectedOptions = [],
}) => {
  // Check if all child permissions are selected
  const isAllSelected = () =>
    options.length > 0 &&
    options.every((opt) =>
      selectedOptions.some((sel) => sel.code === opt.code)
    );

  // Check if an individual checkbox is selected
  const isChecked = (code: string) =>
    selectedOptions.some((sel) => sel.code === code);

  // Handle Select All checkbox
  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    const updated = checked ? options : [];
    onSelectionChange?.(updated);
  };

  // Handle single checkbox toggle
  const handleCheckboxChange = (option: OptionProps) => {
    const updated = isChecked(option.code)
      ? selectedOptions.filter((item) => item.code !== option.code)
      : [...selectedOptions, option];

    onSelectionChange?.(updated);
  };

  return (
    <div className="card card-grid shadow-class h-full min-w-full">
      <div className="card-body">
        <div className="scrollable-x-auto user-manage-table">
          <table className="table table-bordered p-0">
            <thead>
              <tr className="roles-table-head">
                <th className="w-[60px]">
                  {/* <input
                    className="checkbox checkbox-sm"
                    type="checkbox"
                    checked={isAllSelected()}
                    onChange={handleSelectAll}
                  /> */}
                  <Checkbox
                    checked={isAllSelected()}
                    onChange={handleSelectAll}
                    size="small"
                    sx={{
                      // Remove background color when checked
                      "&.Mui-checked": {
                        color: "#fff", // or your preferred color
                        backgroundColor: "#fff",
                      },
                      "&.MuiCheckbox-root": {
                        backgroundColor: "transparent",
                      },
                      // Optional: remove hover background
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  />
                </th>
                <th>
                  <span className="sort asc">
                    <span className="sort-label rolelabel">{headerTitle}</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {options.map((option, index) => (
                <tr key={option.code || index}>
                  <td>
                    {/* <input
                      className="checkbox checkbox-sm"
                      type="checkbox"
                      checked={isChecked(option.code)}
                      onChange={() => handleCheckboxChange(option)}
                    /> */}
                    <Checkbox
                      checked={isChecked(option.code)}
                      onChange={() => handleCheckboxChange(option)}
                      size="small"
                    />
                  </td>
                  <td>
                    <div className="flex flex-col gap-2 role-content">
                      <span className="leading-none font-medium">
                        {option.name}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default RolesAndPermissionCards;
